import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import pinia from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import './styles/index.scss'
import commonHeader from '@/components/header/common-header.vue'
const app = createApp(App)
import { Lazyload } from 'vant'

app.use(router)
app.use(pinia)
app.component('common-header', commonHeader)
app.use(Vant)
app.use(Lazyload)
app.mount('#app')
